<template>
    <b-card no-body>
        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    :buttons="buttons"
                    search
                    pagination="server"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import { ReportApi } from '@/api/report'
export default {
    components:{
        BCard
    },
    data(){
        return{
            loading:false,
            fields:[
                {name:'Cari Kodu',key:'CariCode',thClass:'w-7',tdClass:'text-nowrap'},
                {name:'Cari Adı',key:'CariName', thClass:'w-7',tdClass:'text-nowrap'},
                {name:'Fatura No',key:'DocumentNo',thClass:'w-7',tdClass:'text-nowrap'},
                {name:'Tarih',key:'Tarih',sortable:true,thClass:'w-3',tdClass:'text-nowrap'},
                {name:'Vade Tarihi',key:'VadeTarihi',sortable:true,thClass:'w-3',tdClass:'text-nowrap'},
                {name:'Tutar',key:'Tutar',sortable:true,thClass:'w-7',tdClass:'text-nowrap'},
                {name:'Taksitli Mi?',key:'CanInstallment',sortable:true,thClass:'w-7',tdClass:'text-nowrap'},
                {name:'Açıklama',key:'Description',sortable:true,thClass:'w-7',tdClass:'text-nowrap'},
                {name:'Hata(lar)',key:'Errors',sortable:true,thClass:'w-7',tdClass:'text-nowrap'},
                {name:'E-Posta',key:'Email',sortable:true,thClass:'w-7',tdClass:'text-nowrap'},
                {name:'E-Posta Gönderim Durumu',key:'IsSentWithMail',sortable:true,thClass:'w-7',tdClass:'text-nowrap'},
                {name:'E-Posta Gönderim Tarihi',key:'DateSentWithMail',sortable:true,thClass:'w-7',tdClass:'text-nowrap'},
                {name:'Telefon',key:'PhoneNumber',sortable:true,thClass:'w-7',tdClass:'text-nowrap'},
                {name:'SMS Gönderim Durumu',key:'IsSentWithSms',sortable:true,thClass:'w-7',tdClass:'text-nowrap'},
                {name:'SMS Gönderim Tarihi',key:'DateSentWithSms',sortable:true,thClass:'w-7',tdClass:'text-nowrap'},
            ],
            buttons:[
              
            ],
        }
    },
    methods:{
        provider(data){
            return ReportApi.AutoSendInvoiceData(data)
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
       
    }
}
</script>

<style>

</style>